module.exports = __webpack_public_path__ + "static/media/resume.054749f9.pdf";